import styled from 'styled-components';

export const TeacherListItemContainer = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .link {
    text-decoration: none;
  }
`;

export const TeacherInfo = styled.article`
  .teacher-name,
  .teacher-email {
    font-family: var(--font-sans);
    font-size: 1.25rem;
    color: var(--color-black);
  }

  .teacher-name {
    font-weight: 500;
  }
`;
